import React, { useState } from 'react'
import { Query } from 'react-apollo'
import _ from 'lodash'
import { DatePicker } from 'antd'
import ReactTable from 'react-table'
import moment from 'moment'
import {
  Div, H3, Loading, P,
} from 'konsys-ui'
import config from './config'
import { theme } from '../../../styles/_variables'
import { GET_LOGS } from '../../../constants/graphql/query'
import './style-css.css'
import { Wrapper } from '../../../components/report-components'

const { color } = theme

const Index = () => (
  <Div display='flex' flexDirection='column'>
    <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
      <H3 bold color={color.primaryColor} margin='32px 0'>ประวัติการใช้ระบบ</H3>
      <Div>
      </Div>
    </Div>
    <List />
  </Div>
)

export const List = () => {
  const [current, setCurrent] = useState(0)
  const [filtered, setFiltered] = useState({
    createdAt: [moment().format(), moment().format()],
  })

  return (
    <Wrapper overflow padding='0 0 40px 0' center>
      <Query
        query={GET_LOGS}
        fetchPolicy='cache-and-network'
        variables={{
          limit: 5,
          offset: current * 5,
          orderBy: 'ASC',
          orderField: 'createdAt',
          ...filtered,
        }}
      >{({ data, loading, error }) => {
        if (loading && _.isEmpty(data)) return <Loading center='true' />
        if (error) return <P>เกิดข้อผิดพลาด</P>

        return (
          <Div>
            <DatePicker.RangePicker
              onChange={e => setFiltered({ ...filtered, createdAt: [moment(e[0]).format(), moment(e[1]).format()] })}
              style={{ margin: '0 auto 24px', display: 'block', width: 'fit-content' }}
              defaultValue={[moment(), moment()]}
            />
            <ReactTable
              className='table'
              data={data.LogList.lists} // *
              resizable={false}
              columns={config.columns} // *
              minRows={5}
              manual
              // defaultPageSize={10}
              showPageSizeOptions={false}
              getTdProps={() => ({ disabled: true })} // *
              getTrProps={(state, rowInfo) => { // *
                if (rowInfo) {
                  return {
                    style: {
                      padding: '8px 0',
                      backgroundColor: '#ffffff',
                      borderLeft: rowInfo.original.type === 'CREATE'
                        ? `3px solid ${color.success}`
                        : rowInfo.original.type === 'UPDATE'
                          ? `3px solid ${color.info}`
                          : `3px solid ${color.error}`,
                    },
                  }
                } return {}
              }}
              previousText='ก่อนหน้า'
              nextText='ถัดไป'
              pageText='หน้า'
              ofText='จาก'
              noDataText='ไม่พบข้อมูล'
              page={current}
              pages={Math.ceil(data.LogList.totalFilter / 5)}
              onPageChange={page => setCurrent(page)}
              onFilteredChange={async (newFiltered) => {
                const newOjb = {}
                await newFiltered.forEach((v) => {
                  switch (v.id) {
                    case 'actor.fullname':
                      Object.assign(newOjb, { fullname: v.value })
                      break
                    case 'refId':
                      Object.assign(newOjb, { refId: Number(v.value) })
                      break
                    case 'actor.Roles':
                      Object.assign(newOjb, { roleId: Number(v.value) })
                      break
                    default:
                      Object.assign(newOjb, { [v.id]: v.value })
                      break
                  }
                })
                setFiltered({ ...newOjb, createdAt: filtered.createdAt })
                setCurrent(0)
              }}
            />
            {
              loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
            }
          </Div>
        )
      }}
      </Query>
    </Wrapper>
  )
}

export default Index
